import * as React from 'react';
import * as ReactDOM from 'react-dom';

import './index.css';
import { AppRouter } from './router';

import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <AppRouter />,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx